<div class="health-coaching-bg-image">
  <div class="col-lg-12">
    <div class="event-marquee">
      <div class="marquee-track">
        <!-- Copy 1 -->
        <div class="marquee-content">
          <span class="marquee-pill">
            <i class="bx bx-play-circle"></i>
            Campus Highlights
          </span>

          <span class="marquee-separator"><i class="bx bx-diamond"></i></span>

          <span class="marquee-item marquee-admission">
            <i class="bx bx-bullhorn"></i>
            <strong>Admissions Open 2026:</strong>
            B.E. (Civil), B.E. (CSE), B.E. (CSE - AI & ML), B.E. (CSE - Cyber Security),
            B.Tech. (AI & DS), B.E. (ECE), B.E. (EEE), B.E. (Mechanical), MBA,
            M.E. (CSE), M.E. (Embedded System Technologies),
            M.E. (Thermal Engineering), M.E. (Environmental Engineering)
          </span>

<ng-container *ngFor="let marquee of marqueeList">
  <span class="marquee-separator"><i class="bx bx-diamond"></i></span>

  <span class="marquee-item">
    <i class="bx bx-star"></i>

    <a
      *ngIf="isNaacMarquee(marquee); else normalMarqueeText"
      [href]="naacVisitVideoUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="marquee-link"
    >
      {{ marquee }}
    </a>

    <ng-template #normalMarqueeText>
      {{ marquee }}
    </ng-template>
  </span>
</ng-container>
        </div>

        <!-- Copy 2 for seamless loop -->
        <div class="marquee-content" aria-hidden="true">
          <span class="marquee-pill">
            <i class="bx bx-play-circle"></i>
            Campus Highlights
          </span>

          <span class="marquee-separator"><i class="bx bx-diamond"></i></span>

          <span class="marquee-item marquee-admission">
            <i class="bx bx-bullhorn"></i>
            <strong>Admissions Open 2026:</strong>
            B.E. (Civil), B.E. (CSE), B.E. (CSE - AI & ML), B.E. (CSE - CS),
            B.Tech. (AI & DS), B.E. (ECE), B.E. (EEE), B.E. (Mechanical), MBA,
            M.E. (CSE), M.E. (Embedded System Technologies),
            M.E. (Thermal Engineering), M.E. (Environmental Engineering)
          </span>

          <ng-container *ngFor="let marquee of marqueeList">
            <span class="marquee-separator"><i class="bx bx-diamond"></i></span>
            <span class="marquee-item">
              <i class="bx bx-star"></i>
              {{ marquee }}
            </span>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <!-- HERO -->
<section class="hero-three-section">
  <div class="hero-three-grid">
    <!-- LEFT PANEL -->
    <div class="hero-left-panel">
      <div class="left-panel-inner">
        <owl-carousel-o
          [options]="leftOverlayCarouselOptions"
          class="left-overlay-carousel"
        >
          <ng-template carouselSlide *ngFor="let content of contentSlides">
            <div class="left-content-slide">
              <img
                *ngIf="content.image"
                [src]="content.image"
                [alt]="content.title"
                class="slide-logo"
              />

              <h1>{{ content.title }}</h1>
              <p>{{ content.description }}</p>

              <a
                *ngIf="content.ctaExternalLink; else internalCta"
                [href]="content.ctaExternalLink"
                target="_blank"
                rel="noopener noreferrer"
                class="btn-apply"
              >
                {{ content.ctaText || 'View Video' }}
              </a>

              <ng-template #internalCta>
                <a
                  [routerLink]="content.ctaLink || '/inquiry'"
                  class="btn-apply"
                >
                  {{ content.ctaText || 'Apply Now' }}
                </a>
              </ng-template>
            </div>
          </ng-template>
        </owl-carousel-o>
      </div>
    </div>

    <!-- MIDDLE PANEL -->
    <div class="hero-middle-panel">
      <div class="middle-badge">Admissions Open 2026</div>

      <owl-carousel-o
        [options]="middleCarouselOptions"
        class="middle-image-carousel"
      >
        <ng-template
          carouselSlide
          *ngFor="let bg of backgroundImages; let i = index"
        >
          <div class="middle-slide">
            <img [src]="bg" [alt]="'FMCET Banner ' + (i + 1)" />
            <div class="middle-overlay"></div>

            <div class="middle-caption">
              <h2>Fatima Michael College of Engineering & Technology</h2>
              <p>
                Inspiring academic excellence, innovation, discipline, and
                career-focused learning in a vibrant campus environment.
              </p>
            </div>
          </div>
        </ng-template>
      </owl-carousel-o>
    </div>

    <!-- RIGHT PANEL -->
    <div class="hero-right-panel">
      <div class="right-panel-head">
        <span class="video-kicker">Featured Videos</span>
        <h2>Events Video Gallery</h2>
      </div>

      <div
        #videoViewport
        class="video-scroll-viewport"
        [style.--video-scroll-duration]="videoScrollDuration"
      >
        <div
          class="video-scroll-track"
          [class.is-animated]="shouldAnimateVideos"
        >
          <div
            class="video-scroll-card"
            *ngFor="
              let video of renderedVideoSlides;
              let i = index;
              trackBy: trackByVideo
            "
          >
            <div class="video-frame">
              <video
                #heroVideo
                [poster]="video.poster || ''"
                autoplay
                muted
                loop
                playsinline
                [attr.webkit-playsinline]="'true'"
                preload="none"
                (loadedmetadata)="onVideoMeta(heroVideo)"
                (canplay)="onVideoCanPlay(heroVideo)"
                (error)="onVideoError(heroVideo)"
              >
                <source [attr.data-src]="video.source" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>

            <div class="video-copy">
              <h3>{{ video.title }}</h3>
              <p>{{ video.description }}</p>

              <a
                *ngIf="video.externalUrl"
                [href]="video.externalUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="video-link"
              >
                Open Video
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /RIGHT PANEL -->
  </div>
</section>
  <header class="main-header">
    <h1>WELCOME TO FATIMA MICHAEL COLLEGE OF ENGINEERING & TECHNOLOGY</h1>
  </header>

  <section class="main-layout">
    <div class="row-layout">
      <!-- Left Container -->
      <div class="left-container">
        <div class="welcome-section">
          <h2>About FMCET</h2>
          <p class="about-text">
            "Step Into a World of Possibilities at Fatima Michael College of
            Engineering & Technology, Madurai!"
            <br /><br />
            At FMCET, learning isn’t just about books—it’s about exploring,
            discovering, and growing in a place that inspires greatness.
            Founded in 2009 by Ln. Dr. M. Stalin Arockiaraj, Chairman of
            St. Michael Group of Institutions, our mission is clear: to provide
            top-quality education in a modern, supportive environment. With
            cutting-edge facilities and a passion for excellence, we shape
            students into creative thinkers and smart problem-solvers who make a
            difference in the world.
            <br /><br />
            From experienced faculty and vibrant libraries to advanced labs and
            spacious playgrounds, every corner of FMCET is designed to make
            learning exciting and unforgettable.
          </p>
        </div>

        <div class="upcoming-events">
          <div class="events-head">
            <h2>Upcoming Events & Announcements</h2>
            <span class="events-count">{{ eventList.length || 0 }} Updates</span>
          </div>

          <div class="events-showcase scrollable-events">
            <ng-container *ngIf="eventList.length; else noEventsTemplate">
              <div class="events-track events-track-scroll">
                <button
                  type="button"
                  class="event-card"
                  *ngFor="
                    let event of eventList;
                    let i = index;
                    trackBy: trackByEvent
                  "
                  (click)="showPopupByEvent(event)"
                >
                  <div class="event-thumb-wrap">
                    <img
                      [src]="getEventImage(event.event_image)"
                      [alt]="event.event_title"
                      class="event-thumb"
                    />
                  </div>

                  <div class="event-copy">
                    <span class="event-date">
                      {{ formatEventDate(event.event_date) }}
                    </span>
                    <h3>{{ event.event_title }}</h3>
                    <span class="event-action">Click to view poster</span>
                  </div>
                </button>
              </div>
            </ng-container>

            <ng-template #noEventsTemplate>
              <div class="no-events-card">
                <div class="no-events-title">No events available</div>
                <p>Please add event posters from backend to display here.</p>
              </div>
            </ng-template>
          </div>
        </div>

        <!-- Event Popup Modal -->
        <div
          *ngIf="selectedEventImage"
          class="popup-overlay"
          (click)="closePopup()"
        >
          <div class="popup-content" (click)="$event.stopPropagation()">
            <button class="close-btn" type="button" (click)="closePopup()">
              ✖
            </button>

            <img
              [src]="selectedEventImage"
              [alt]="selectedEventDescription || 'Event Image'"
              class="popup-image"
            />

            <p class="popup-text">{{ selectedEventDescription }}</p>
          </div>
        </div>
      </div>

      <!-- Right Container -->
      <div class="right-container">
        <div class="course-bucket ug-bucket">
          <div class="bucket-header">
            <h2>UG Courses</h2>
            <span class="bucket-count">8 Courses</span>
          </div>

          <div class="bucket-grid">
            <a routerLink="/civil" class="bucket-item">
              B.E. Civil Engineering
            </a>
            <a routerLink="/cse" class="bucket-item">
              B.E. Computer Science & Engineering
            </a>
            <a routerLink="/ai" class="bucket-item">
              B.E. CSE (Artificial Intelligence & Machine Learning)
            </a>
            <button
              type="button"
              class="bucket-item popup-course-item"
              (click)="showCoursePopup('aids')"
            >
              <span>B.Tech. Artificial Intelligence &amp; Data Science</span>
              <i class="bx bx-info-circle"></i>
            </button>
            <a routerLink="/cs" class="bucket-item">
              B.E. CSE (Cyber Security)
            </a>
            <a routerLink="/ece" class="bucket-item">
              B.E. Electronics & Communication Engineering
            </a>
            <a routerLink="/eee" class="bucket-item">
              B.E. Electrical & Electronics Engineering
            </a>
            <a routerLink="/mech" class="bucket-item">
              B.E. Mechanical Engineering
            </a>
          </div>
        </div>

    <div class="course-bucket pg-bucket">
  <div class="bucket-header">
    <h2>PG Courses</h2>
    <span class="bucket-count">5 Courses</span>
  </div>

  <div class="bucket-grid">
    <a routerLink="/mba" class="bucket-item">
      M.B.A. Masters of Business Administration
    </a>

    <a routerLink="/cse" class="bucket-item">
      M.E. Computer Science &amp; Engineering
    </a>

    <a routerLink="/eee" class="bucket-item">
      M.E. Embedded System Technologies
    </a>

    <a routerLink="/mech" class="bucket-item">
      M.E. Thermal Engineering
    </a>

    <button
      type="button"
      class="bucket-item popup-course-item"
      (click)="showCoursePopup('environmentalEngineering')"
    >
      <span>M.E. Environmental Engineering</span>
      <i class="bx bx-info-circle"></i>
    </button>
  </div>
</div>
      </div>
    </div>
  </section>

  <!-- Course Popup -->
  <div
    *ngIf="selectedCoursePopup"
    class="course-popup-overlay"
    (click)="closeCoursePopup()"
  >
    <div class="course-popup-card" (click)="$event.stopPropagation()">
      <button
        type="button"
        class="course-popup-close"
        (click)="closeCoursePopup()"
        aria-label="Close course popup"
      >
        <i class="bx bx-x"></i>
      </button>

      <div class="course-popup-hero">
        <span class="course-popup-kicker">New Course Highlight</span>
        <h2>{{ selectedCoursePopup.title }}</h2>
        <p>{{ selectedCoursePopup.subtitle }}</p>

        <div class="course-popup-meta">
          <span *ngIf="selectedCoursePopup.approval">
            {{ selectedCoursePopup.approval }}
          </span>
          <span *ngIf="selectedCoursePopup.intake">
            {{ selectedCoursePopup.intake }}
          </span>
          <span>Scope &amp; Opportunities</span>
        </div>
      </div>

      <div class="course-popup-body">
        <div class="course-popup-section">
          <h3>Programme Overview</h3>
          <p>{{ selectedCoursePopup.overview }}</p>
        </div>

        <div class="course-popup-section">
          <h3>{{ selectedCoursePopup.scopeTitle }}</h3>

          <div class="course-point-list">
            <div
              class="course-point"
              *ngFor="let point of selectedCoursePopup.scopePoints; let i = index"
            >
              <span class="course-point-index">{{ i + 1 }}</span>
              <p>{{ point }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <section>
    <div class="quality-policy">
      <div class="quality-policy-header">
        <h2>Our Quality Policy</h2>
        <p>
          FMCET is committed to be a leader to impart quality education,
          training & research in Science, Engineering, Technology & Management
          with professional staff & Infrastructure for developing skilled
          manpower to meet the growing needs of socio-economic progress of our
          nation.
        </p>
      </div>

      <div class="quality-policy-points">
        <div class="points-column">
          <div class="point">1. Providing world class Infrastructure facilities.</div>
          <div class="point">2. Equipping the facilities with vibrant learning forum.</div>
          <div class="point">3. Empowering youth with technical skills & leadership.</div>
        </div>

        <div class="points-column">
          <div class="point">4. Providing exuberant teaching & research ambience.</div>
          <div class="point">
            5. Networking with global institutions of excellence, industries &
            research organizations.
          </div>
          <div class="point">
            6. Engaging through outreach, community development and
            enterpreneurial initiatives.
          </div>
        </div>
      </div>

      <p class="quality-footnote">
        We shall ensure its continuing suitability by reviewing the quality
        policy periodically in every Management review meeting.
      </p>
    </div>
  </section>

  <section>
    <div class="vision-mission-wrapper">
      <div class="vision-box">
        <div class="vision-content">
          <h2>Vision</h2>
          <p>
            To be one of the leading and preferred engineering colleges in
            education, research and ethics, and achieve greater recognition for
            our efforts to make the world look to us for technology and
            methodology for future trends and innovations.
          </p>
        </div>
        <span class="vision-icon">
          <img src="assets/img/vision-icon.png" alt="Vision Icon" />
        </span>
      </div>

      <div class="mission-box">
        <div class="mission-content">
          <h2>Mission</h2>
          <p>
            To develop high-quality technical education and technocrats with a
            sound grip on basic engineering principles, technical, and
            managerial skills.<br />
            To innovate research capabilities, and exemplary professional
            conduct to lead and to use technology for the progress of
            humanity.<br />
            To adapt themselves to changing technological conditions with the
            highest ethical values.
          </p>
        </div>
        <span class="mission-icon">
          <img src="assets/img/mission-icon.png" alt="Mission Icon" />
        </span>
      </div>
    </div>
  </section>
</div>